import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEmployeeAuth } from "../auth/EmployeeAuthContext";

const ProtectedEmployeeRoute = () => {
  const { isAuthenticated } = useEmployeeAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/employee/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedEmployeeRoute;
